import type { FC } from 'react';

import { get } from 'lodash';

import type { ApiResponse } from '@/types/common/api.type';
import type { RouteManagerInterface } from '@/utils/route/routeManager';
import type { TDetailServiceParams } from '../../types/EntityType.types';

export abstract class Entity {
    routeManager: RouteManagerInterface;

    public constructor(routeManager: RouteManagerInterface) {
        this.routeManager = routeManager;
    }

    public abstract getTitleTemplate(response: any): string;

    public abstract getEntityComponent(): FC<any>;

    public abstract getDetailService(
        params: TDetailServiceParams
    ): Promise<ApiResponse<any>>;

    public abstract getRouteDetail(): string;

    /**
     * Get field name, support nested: `a.b.c`
     */
    public abstract getFieldName(): string;

    public abstract getIncludeProperties(): any;

    public abstract getDetailUrl(id: string): string;

    public abstract showDetailButton(): boolean;

    public getTitle(response: any): string {
        if (!response) {
            return '';
        }

        return get(response, this.getFieldName(), '');
    }
}
